import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';
import { resetValues } from '~/store/modules/locomotivaRegistration/actions';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestVeiculos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'veiculos/locomotivas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(resetValues());

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteVeiculo({ payload }) {
  try {
    const { idveiculo, params } = payload;

    yield call(api.delete, `veiculos/${idveiculo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    yield put(resetValues());

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { veiculo, params } = payload;

    yield call(api.post, 'veiculos', veiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    yield put(resetValues());

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/locomotivas');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idveiculo } = payload;

    const { data } = yield call(api.get, `veiculos/${idveiculo}`);

    yield put(resetValues());

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { veiculo, params } = payload;

    yield call(api.put, 'veiculos', veiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    yield put(resetValues());

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/locomotivas');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'veiculos/locomotivas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    yield put(resetValues());

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@locomotiva/VEICULOS_IN_REQUEST', requestVeiculos),
  takeLatest('@locomotiva/DELETE_VEICULO', deleteVeiculo),
  takeLatest('@locomotiva/SUCCESS_REMOVE', requestVeiculos),
  takeLatest('@locomotiva/STORE_VEICULO', store),
  takeLatest('@locomotiva/FIND_VEICULO', find),
  takeLatest('@locomotiva/UPDATE_VEICULO', update),
  takeLatest('@locomotiva/RECORD_FILTERING', applyedFilters),
]);
